import './UserSubscriptions.scss';
import axios from 'axios';
import { React, useEffect, useState } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import ReusableTable from '../reusable-table/ReusableTable.jsx';
import config from '../../config/config.json';

function UserSubscriptions(props) {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const header = ['Product', 'Renewal Date'];

  async function getUserSubscriptions() {
    try {
      const baseurl = props.env.USE_LOCAL === "true" ? config.apiLocalHost : props.env.BASE_URL;
      let result = await axios.get(
        baseurl +
        `v${props.env.API_VERSION}/${props.subscriberDetails.subscriberID}/${props.subscriberDetails.password}/UserSubscriptions?api-version=${props.env.API_VERSION}.0`
      );
      localStorage.setItem('Subscriptions', JSON.stringify(Object.values(result.data.products || [])));
      return Object.values(result.data.products || []);
    } catch (error) {
      console.error('There was an error!', error);
      return {};
    }
  }

  useEffect(() => {
    const savedProducts = localStorage.getItem('Subscriptions');
    setLoading(true);
    async function fetchData() {
      const data = await getUserSubscriptions();
      setSubscriptions(data || []);
      setLoading(false);
    }
    if (!savedProducts) {
      fetchData();
    } else {
      setSubscriptions(JSON.parse(savedProducts));
      setLoading(false);
    }
  }, [props.env, props.subscriberDetails]);

  return (
    <div className="subscriptions-container">
      {loading ? (
        <div className='loading-container'>
          <PulseLoader className="scale-loader-spinner"
            color={'#180a48'}
            loading={true}
            size={40}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          <div className="spinner-text-container">
            <span className='spinner-text'>Loading data...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className='description'>
            <span>The below table lists the products this account is currently subscribed to and their renewal date.</span>
          </div>
          <ReusableTable body={subscriptions} header={header} />
        </div>
      )
      }
    </div >
  );
}
export default UserSubscriptions;